import { render, staticRenderFns } from "./SenEditor.vue?vue&type=template&id=1cd332c4&scoped=true&"
import script from "./SenEditor.vue?vue&type=script&lang=js&"
export * from "./SenEditor.vue?vue&type=script&lang=js&"
import style0 from "./SenEditor.vue?vue&type=style&index=0&id=1cd332c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd332c4",
  null
  
)

export default component.exports